export class FeatureDTO {
    active: boolean;

    constructor(sub?) {
        sub = sub || {};

        this.active = sub.active || false;
    }
}
